// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Ci2MT {
    flex: 1;
  }
  .pk735 {
    flex: 2;
  }
  .BcE23 {
    flex: 3;
  }
  .OvMiv {
    flex: 4;
  }
  .mY05G {
    flex: 5;
  }
  .ifdPP {
    flex: 6;
  }
  .uT43d {
    flex: 7;
  }
  .e4S_3 {
    flex: 8;
  }
  .beNmD {
    flex: 9;
  }
  .JhxSl {
    flex: 50%;
  }
  .R1nR2 {
    max-width: 45%;
  }
  .iQR4l {
    display: flex;
    flex-direction: row;
  }
  .c8sVM {
    display: flex;
    flex-direction: column;
  }
  .vv7EB {
    align-items: flex-start;
  }
  .guanA {
    align-items: center;
  }
  .JoxER {
    align-items: flex-end;
  }
  .ai4I0 {
    align-items: baseline;
  }
  .yNGQJ {
    justify-content: flex-start;
  }
  .i7FmM {
    justify-content: flex-end;
  }
  .CPnZ2 {
    justify-content: center;
  }
  .mDJjD {
    justify-content: space-between;
  }
  .XZUqZ {
    justify-content: space-around;
  }
  .QMhXF {
    align-self: center;
  }
  .mUEEU {
    align-self: flex-start;
  }
  .B2SVY {
    align-self: stretch;
  }
  .iMS6f {
    align-self: flex-end;
  }
  .JM8V1 {
    flex-wrap: wrap;
  }
  .nKGLU {
    display: flex;
  }`, "",{"version":3,"sources":["webpack://./src/components/flex.css"],"names":[],"mappings":"AAAA;IACI,OAAO;EACT;EACA;IACE,OAAO;EACT;EACA;IACE,OAAO;EACT;EACA;IACE,OAAO;EACT;EACA;IACE,OAAO;EACT;EACA;IACE,OAAO;EACT;EACA;IACE,OAAO;EACT;EACA;IACE,OAAO;EACT;EACA;IACE,OAAO;EACT;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf","sourcesContent":[".flex {\n    flex: 1;\n  }\n  .flex2 {\n    flex: 2;\n  }\n  .flex3 {\n    flex: 3;\n  }\n  .flex4 {\n    flex: 4;\n  }\n  .flex5 {\n    flex: 5;\n  }\n  .flex6 {\n    flex: 6;\n  }\n  .flex7 {\n    flex: 7;\n  }\n  .flex8 {\n    flex: 8;\n  }\n  .flex9 {\n    flex: 9;\n  }\n  .flex50 {\n    flex: 50%;\n  }\n  .flex45 {\n    max-width: 45%;\n  }\n  .row {\n    display: flex;\n    flex-direction: row;\n  }\n  .column {\n    display: flex;\n    flex-direction: column;\n  }\n  .itemsStart {\n    align-items: flex-start;\n  }\n  .itemsCenter {\n    align-items: center;\n  }\n  .itemsEnd {\n    align-items: flex-end;\n  }\n  .itemsBaseline {\n    align-items: baseline;\n  }\n  .justifyStart {\n    justify-content: flex-start;\n  }\n  .justifyEnd {\n    justify-content: flex-end;\n  }\n  .justifyCenter {\n    justify-content: center;\n  }\n  .justifyBetween {\n    justify-content: space-between;\n  }\n  .justifyAround {\n    justify-content: space-around;\n  }\n  .selfCenter {\n    align-self: center;\n  }\n  .selfStart {\n    align-self: flex-start;\n  }\n  .selfStretch {\n    align-self: stretch;\n  }\n  .selfEnd {\n    align-self: flex-end;\n  }\n  .wrap {\n    flex-wrap: wrap;\n  }\n  .displayFlex {\n    display: flex;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flex": `Ci2MT`,
	"flex2": `pk735`,
	"flex3": `BcE23`,
	"flex4": `OvMiv`,
	"flex5": `mY05G`,
	"flex6": `ifdPP`,
	"flex7": `uT43d`,
	"flex8": `e4S_3`,
	"flex9": `beNmD`,
	"flex50": `JhxSl`,
	"flex45": `R1nR2`,
	"row": `iQR4l`,
	"column": `c8sVM`,
	"itemsStart": `vv7EB`,
	"itemsCenter": `guanA`,
	"itemsEnd": `JoxER`,
	"itemsBaseline": `ai4I0`,
	"justifyStart": `yNGQJ`,
	"justifyEnd": `i7FmM`,
	"justifyCenter": `CPnZ2`,
	"justifyBetween": `mDJjD`,
	"justifyAround": `XZUqZ`,
	"selfCenter": `QMhXF`,
	"selfStart": `mUEEU`,
	"selfStretch": `B2SVY`,
	"selfEnd": `iMS6f`,
	"wrap": `JM8V1`,
	"displayFlex": `nKGLU`
};
export default ___CSS_LOADER_EXPORT___;
